<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex :spacing="3">
        <flex-col :span="24">
          <test-toolbar />
        </flex-col>
      </flex>
      <flex-col equal-height :span="6" md8 sm12 xs24 v-for="(lightness, index) in swatches" :key="index">
        <card full-height align="center">
          <card-title :bg-color="myBrandColor" :bg-color-lightness="lightness">
            <code :class="['truncate', 'text-xs']">.bg-{{ myBrandColor }}-{{ lightness }}</code>
          </card-title>
          <card-text :class="[`bg-${myBrandColor}-${swatches[swatches.length - index - 1]}`]">
            <code :class="['truncate', 'text-xs', `text-${myBrandColor}-${lightness}`]">.text-{{myBrandColor}}-{{lightness}}</code>
          </card-text>
          <card-title :bg-color="myBrandColor" :bg-color-lightness="lightness" :class="['border-2', `border-${myBrandColor}-${swatches[swatches.length - index - 1]}`]">
            <code :class="['truncate', 'text-xs']">.border-{{ myBrandColor }}-{{ lightness }}</code>
          </card-title>
        </card>
      </flex-col>
    </flex>
    <brand-color :name="myBrandColor" :hex="hex" />
  </container>
</template>
<script>
export default {
  name: 'PageBrandColor',
  data () {
    return {
      hex: '#8508f8',
      myBrandColor: 'my-brand',
      swatches: [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content/brand-color.vue